import { useState } from 'react';
import { useLoaderData, useNavigate } from 'react-router-dom';
import { Flex, Float, IconButton } from '@chakra-ui/react';
import { ColDef } from '@ag-grid-community/core';
import { UserDto } from '../../lib/api';
import { Grid } from '@/components/ui/grid';
import { UserManagementActionRenderer } from './user-management-action-renderer';
import { PlusIcon } from 'lucide-react';
import { capitalize } from '@/utils/capitalize';

export const OrganizationUserManagementPage = () => {
    const navigate = useNavigate();
    const data = useLoaderData() as UserDto[];

    const [colDefs] = useState<ColDef<UserDto>[]>([
        {
            width: 60,
            cellRenderer: UserManagementActionRenderer,
            suppressHeaderFilterButton: true,
            resizable: false,
        },
        {
            headerName: 'Name',
            valueGetter: (params) => {
                if (params.data) {
                    return `${capitalize(params.data.firstName)} ${capitalize(params.data.lastName)}`;
                }
            },
            minWidth: 150,
            flex: 1,
            filter: 'agTextColumnFilter',
            floatingFilter: true,
        },
        { field: 'email', minWidth: 250, flex: 1, filter: 'agTextColumnFilter', floatingFilter: true },
        {
            field: 'discipline',
            minWidth: 100,
            maxWidth: 100,
            flex: 1,
            filter: 'agTextColumnFilter',
            floatingFilter: true,
            resizable: false,
        },
        { field: 'active', width: 100, filter: 'agTextColumnFilter', floatingFilter: true, resizable: false },
        { field: 'locked', width: 100, filter: 'agTextColumnFilter', floatingFilter: true, resizable: false },
        { field: 'verified', width: 100, filter: 'agTextColumnFilter', floatingFilter: true, resizable: false },
    ]);

    return (
        <Flex flexDirection="column" style={{ width: '100%', height: '100%' }} gap="10px" position="relative">
            <Float zIndex={10} placement="bottom-end" offset="10">
                <IconButton
                    rounded="full"
                    onClick={() => {
                        navigate('/user/create');
                    }}>
                    <PlusIcon />
                </IconButton>
            </Float>
            <Grid
                suppressCellFocus
                enableCellTextSelection
                rowSelection="single"
                suppressRowHoverHighlight
                columnDefs={colDefs}
                rowData={data}
            />
        </Flex>
    );
};
